import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts'
import { useTranslation } from 'react-i18next'

const DailyVolumeChart = ({ data }) => {
  const { t } = useTranslation()

  // Define colors for each body part to match the radar chart if possible,
  // or just use a nice palette.
  // Using the orange theme of the app.
  const barColor = 'rgba(210, 153, 238, 0.6)' // semi-transparent purple

  // Filter out zero values to avoid clutter
  const chartData = data.filter(d => d.volume > 0)

  if (chartData.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-gray-500">
        {t('no_data_for_selected_date')}
      </div>
    )
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-[#2c2c2e] p-3 border border-gray-700 rounded shadow-lg">
          <p className="text-white font-bold">{label}</p>
          <p className="text-orange-500">{`${payload[0].value} kg`}</p>
        </div>
      )
    }
    return null
  }

  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 5, right: 30, left: 40, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#333" horizontal={false} />
          <XAxis type="number" stroke="#888" tick={{ fill: '#888' }} />
          <YAxis
            dataKey="name"
            type="category"
            stroke="#888"
            tick={{ fill: '#888', fontSize: 12 }}
            width={60}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: '#ffffff10' }} />
          <Bar dataKey="volume" fill={barColor} radius={[0, 4, 4, 0]}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={barColor} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default DailyVolumeChart
